import http from '@/http-common'
import Title from '@/components/TitlePage.vue'

export default {
  name: 'ReportKind',
  components: {Title},
  data() {
    return {
      items: [],
      columns: [
        {key: 'code', label: 'Код', sortable: true},
        {key: 'name', label: 'Наименование', sortable: true},
        {key: 'countAll', label: 'Кол-во мероприятий', sortable: true, class: "width10"},
        {key: 'countDone', label: 'Кол-во проведенных', sortable: true, class: "width10"},
        {key: 'plan', label: 'План', tdClass: 'columnClass1', sortable: true},
        {key: 'fakt', label: 'Факт', tdClass: 'columnClass1', sortable: true},
        {key: 'returnSumm', label: 'Возврат', tdClass: 'columnClass1', sortable: true},
        {key: 'ostatok', label: 'Остаток', tdClass: 'columnClass1', sortable: true}
      ],
      dat1: null,
      dat2: null,
      downloadFileLink: '',
      dfileName: '',
      modalLoadOpened: false,
      ekpTypeList: [],
      ekptypeId: null
    }
  },
  created() {
    this.dat1 = new Date().getFullYear().toString() + "-01-01";
    this.dat2 = new Date().getFullYear().toString() + "-12-31";
    this.downloadFileLink = '';
    this.loadItems();
    this.loadEkpTypes()
  },
  methods: {
    loadEkpTypes() {
      var vm = this;
      var ekptyp = {}
      ekptyp.value = null
      ekptyp.text = 'Все'
      vm.ekpTypeList = [ekptyp]
      http.get('/workkind/EKP_TYPE/list')
      .then((response) => {
        response.data.forEach(function (x) {
          x.value = x.id;
          x.text = x.name;
          vm.ekpTypeList.push(x)
        })
      })
      .catch((error) => console.log(error.message));
    },
    getBalance(rec) {
      return (rec.plan - rec.fakt + rec.returnSumm).toFixed(2);
    },
    validate_date(value) {
      var arrD = value.split("-"); // yyyy-mm-dd
      arrD[1] -= 1;
      var sTmp = arrD[0] + '-' + arrD[1] + '-' + arrD[2];
      return new Date(sTmp) !== 'Invalid Date';
    },
    checkDate1() {
      if (this.validate_date(this.dat1) && this.dat1 > this.dat2) {
        this.dat2 = this.dat1
      }
    },
    checkDate2() {
      if (this.validate_date(this.dat2) && this.dat1 > this.dat2) {
        this.dat1 = this.dat2
      }
    },
    loadItems() {
      var vm = this;
      var filter = '';
      if (this.ekptypeId && this.ekptypeId > 0) {
        filter += '&ekptypeId=' + this.ekptypeId;
      }
      if (this.dat1) {
        filter += '&dat1=' + this.dat1;
      }
      if (this.dat2) {
        filter += '&dat2=' + this.dat2;
      }
      vm.modalLoadOpened = true;
      http.get('/report/sportkind?' + filter)
      .then((response) => {
        vm.items = response.data;
      })
      .catch((error) => console.log(error.message))
      .finally(() => vm.modalLoadOpened = false);
    },
    exportExcel() {
      this.downloadFileLink = '';
      if (this.items && this.items.length > 0) {
        http.post('/report/sportkind/excel', this.items)
        .then((response) => {
          if (response.data.ok || response.data.name !== '') {
            this.downloadFileLink = '/report/download?name=' + encodeURIComponent(response.data.name);
            this.dfileName = 'Итоговый отчёт по разделам.xls';
          } else {
            alert("Отчет не сформирован!");
          }
        })
        .catch((error) => console.log(error.message));
      } else {
        alert("Отчет пустой!");
      }
    },
    downloadFile() {
      var vm = this;
      this.modalLoadOpened = true;
      http.get(this.downloadFileLink,
          {
            responseType: 'arraybuffer',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/pdf'
            }
          }
      ).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', vm.dfileName); //or any other extension
        document.body.appendChild(link);
        link.click();
      }).finally(() => vm.modalLoadOpened = false);
    }
  }
}
